import type { SVGProps } from "react";
import type { PlaceType } from "~/lib/api";

import { Icon, type IconType } from "./icon";
import { AccommodationIcon } from "./accommodation";
import { ActivityIcon } from "./activity";
import { BackcountryIcon } from "./backcountry";
import { BarIcon } from "./bar";
import { BikeParkIcon } from "./bike-park";
import { BikeShopIcon } from "./bike-shop";
import { CafeIcon } from "./cafe";
import { CampgroundIcon } from "./campground";
import { ConvenienceStoreIcon } from "./convenience-store";
import { CoworkingSpaceIcon } from "./coworking-space";
import { DepartmentStoreIcon } from "./department-store";
import { FreshMarketIcon } from "./fresh-market";
import { GroceryIcon } from "./grocery-store";
import { GymIcon } from "./gym";
import { HikingIcon } from "./hiking";
import { LibraryIcon } from "./library";
import { MarkerIcon } from "./marker";
import { MtbTrailIcon } from "./mtb-trail";
import { ParkIcon } from "./public-park";
import { PharmacyIcon } from "./pharmacy";
import { PublicTransportIcon } from "./public-transport";
import { RestaurantIcon } from "./restaurant";
import { SkiBoardShopIcon } from "./ski-board-shop";
import { SkiResortIcon } from "./ski-resort";
import { SpaIcon } from "./spa";
import { SwimmingPoolIcon } from "./swimming-pool";

type SvgIconProps = SVGProps<SVGSVGElement>;
type SvgIconComponent = (props: SvgIconProps) => JSX.Element;

const svgIcons: Partial<Record<PlaceType, SvgIconComponent>> = {
  restaurant: RestaurantIcon,
  cafe: CafeIcon,
  "grocery-store": GroceryIcon,
  hiking: HikingIcon,
  accommodation: AccommodationIcon,
  backcountry: BackcountryIcon,
  bar: BarIcon,
  "coworking-space": CoworkingSpaceIcon,
  gym: GymIcon,
  "bike-park": BikeParkIcon,
  "bike-shop": BikeShopIcon,
  "ski-resort": SkiResortIcon,
  "convenience-store": ConvenienceStoreIcon,
  "swimming-pool": SwimmingPoolIcon,
  spa: SpaIcon,
  "department-store": DepartmentStoreIcon,
  "public-park": ParkIcon,
  library: LibraryIcon,
  "fresh-market": FreshMarketIcon,
  pharmacy: PharmacyIcon,
  "public-transport": PublicTransportIcon,
  "mtb-trail": MtbTrailIcon,
  activity: ActivityIcon,
  campground: CampgroundIcon,
  "ski-board-shop": SkiBoardShopIcon,
};

const iconifyIcons: Partial<Record<PlaceType, IconType>> = {
  parking: "parking",
  hut: "cabin",
  "hot-spring": "hot-spring",
};

interface PlaceTypeIconProps extends Omit<SvgIconProps, "type"> {
  type: PlaceType | null | undefined;
}

export function PlaceTypeIcon({ type, className, ...props }: PlaceTypeIconProps) {
  if (type) {
    const SvgIcon = svgIcons[type];
    if (SvgIcon) return <SvgIcon className={className} {...props} />;

    const iconifyIcon = iconifyIcons[type];
    if (iconifyIcon) return <Icon i={iconifyIcon} className={className} />;
  }

  return <MarkerIcon className={className} {...props} />;
}
